<script>
	import Image from "svelte-image";
	export let name;
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com">
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
	<link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
</svelte:head>

<main>
	<div class="wrapper">
		<Image src="logo.svg" class="logo" />
		<p>A startup studio based in Silver Lake, Los Angeles, California.</p><p>Contact <a href="mailto:huy@hawflake.com">huy@hawflake.com</a> for more.</p>
	</div>
</main>

<style>
body, html {
	height: 100%;
	background: #dfdfdf;
	  font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
	  font-optical-sizing: auto;
	font-weight: 400;

}
	main {
		  display: flex;
		justify-content: center;
			align-items: center;
			height: 100%;

	}
	.wrapper {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		max-width: 360px;
	}
	p {
		font-size:.9em;
	}
</style>
